<template>
  <LoaderFullPage v-if="stakeholdersStore.loading" />
  <template v-else>
    <div v-if="stakeholdersStore.authorsStakeholder.length">
      <div class="stakeholders-ranking__wrapper">
        <!-- Cards -->
        <AuthorCard
          v-for="author in stakeholdersStore.authorsStakeholder"
          :key="author._id"
          :author="author"
        />
      </div>
      <!-- Pagination -->
      <PaginationElement
        v-if="stakeholdersStore.authorsCountStakeholder"
        :key="`${stakeholdersStore.authorsCountStakeholder}${stakeholdersStore.selectedFilters.from}${stakeholdersStore.selectedFilters.size}`"
        :total-items="stakeholdersStore.authorsCountStakeholder"
        :current-page="stakeholdersStore.selectedFilters.from"
        :items-limit="stakeholdersStore.selectedFilters.size"
        @change-current-page="changeCurrentPage"
      />
    </div>
    <NoData v-else-if="stakeholdersStore.hasActiveFilters" />
    <NoDataFollawed
      v-else-if="
        !stakeholdersStore.loading &&
        stakeholdersStore.authorsCountStakeholder === 0 &&
        stakeholdersStore.isFollawedActive
      "
    />
    <NoData v-else />
  </template>
</template>

<script setup>
import { useRoute } from "vue-router";

import AuthorCard from "@follaw-fr/components/social-media/molecules/AuthorCard.vue";
import PaginationElement from "@follaw-fr/components/reusable/atoms/PaginationElement.vue";
import NoDataFollawed from "@follaw-fr/components/reusable/atoms/NoDataFollawed.vue";
import NoData from "@follaw-fr/components/reusable/atoms/NoData.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const stakeholdersStore = useStakeholdersStore();
const userSettingsStore = useUserSettingsStore();
const route = useRoute();

const changeCurrentPage = async (from) => {
  stakeholdersStore.selectedFilters.from = from;
  await stakeholdersStore.getAuthorsStakeholdersList();
};

stakeholdersStore.isFollawedActive = route.fullPath.includes("follawed");

if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  stakeholdersStore.selectedFilters.from = 0;
  stakeholdersStore.getAuthorsStakeholdersList();
}
</script>

<style scoped lang="scss">
.stakeholders-ranking__wrapper {
  display: grid;
  grid-gap: 10px;
  flex-grow: 3;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
}
</style>
